import { translate } from 'src/app/project/features/translate/translate';
import VDialogPW from '@voly/ui-components/src/v2/VDialogPW';
import VText from '@voly/ui-components/src/v2/VText';

interface RemoveDigitalSignatureProps {
  open: boolean;
  onClose: () => void;
  onDelete: () => void;
}

const RemoveDigitalSignatureModal = ({ open, onClose, onDelete }: RemoveDigitalSignatureProps) => {
  const handleOpenChange = (details: { open: boolean }): void => {
    if (!details.open) {
      onClose();
    }
  };

  return (
    <VDialogPW
      open={open}
      onOpenChange={handleOpenChange}
      onOk={onDelete}
      loading={false}
      saveButtonColor="destructive"
      title={translate('remove_signature')}
      body={<VText>{translate('remove_signature_message')}</VText>}
      saveBtnText={translate('remove')}
    />
  );
};
export default RemoveDigitalSignatureModal;
